export abstract class AToken {}

abstract class ABooleanToken extends AToken {
  constructor(public readonly value: boolean) {
    super();
  }
}

export class TextToken extends AToken {
  constructor(public readonly value: string) {
    super();
  }
}

export class BoldToken extends ABooleanToken {}

export class ItalicToken extends ABooleanToken {}

export class WaveToken extends ABooleanToken {}

export class IndentToken extends AToken {
  constructor(public readonly indent: number) {
    super();
  }
}
